export const faceSwapeRoleOptions = {
    gender: {
      label: 'Gender',
      options: {
        man: 'Man',
        woman: 'Woman'
      }
    },
    age: {
      label: 'Age',
      options: {
        baby: 'Baby (0-2)',
        child: 'Child (3-12)',
        teenager: 'Teenager (13-19)',
        youngAdult: 'Young Adult (20-39)',
        middleAged: 'Middle-aged (40-59)',
        senior: 'Senior (60+)'
      }
    },
    expression: {
      label: 'Expression',
      options: {
        happy: 'Happy',
        laughing: 'Laughing',
        serious: 'Serious',
        calm: 'Calm',
        surprised: 'Surprised',
        sad: 'Sad',
        angry: 'Angry',
        thoughtful: 'Thoughtful'
      }
    },
    eyeColor: {
      label: 'Eye Color',
      options: {
        black: 'Black',
        brown: 'Brown',
        blue: 'Blue',
        green: 'Green',
        gray: 'Gray',
        hazel: 'Hazel'
      }
    },
    hairStyle: {
      label: 'Hair Style',
      options: {
        buzzCut: 'Buzz cut',
        crewCut: 'Crew cut',
        pixieCut: 'Pixie cut',
        bobCut: 'Bob cut',
        shoulderLength: 'Shoulder-length',
        longStraight: 'Long straight',
        longWavy: 'Long wavy',
        curly: 'Curly',
        afro: 'Afro',
        ponytail: 'Ponytail',
        highBun: 'High bun',
        lowBun: 'Low bun',
        bald: 'Bald'
      }
    },
    hairColor: {
      label: 'Hair Color',
      options: {
        black: 'Black',
        darkBrown: 'Dark brown',
        lightBrown: 'Light brown',
        blonde: 'Blonde',
        platinumBlonde: 'Platinum blonde',
        red: 'Red',
        auburn: 'Auburn',
        gray: 'Gray',
        white: 'White',
        colorful: 'Colorful'
      }
    },
    beard: {
      label: 'Beard',
      options: {
        cleanShaven: 'Clean shaven',
        fiveOClockShadow: '5 o\'clock shadow',
        lightStubble: 'Light stubble',
        heavyStubble: 'Heavy stubble',
        goatee: 'Goatee',
        vanDyke: 'Van Dyke',
        fullBeard: 'Full beard',
        handlebarMustache: 'Handlebar mustache',
        pencilMustache: 'Pencil mustache'
      }
    },
    nationality: {
      label: 'Nationality',
      options: {
        afghan: 'Afghan',
        albanian: 'Albanian',
        algerian: 'Algerian',
        american: 'American',
        andorran: 'Andorran',
        angolan: 'Angolan',
        argentine: 'Argentine',
        armenian: 'Armenian',
        australian: 'Australian',
        austrian: 'Austrian',
        azerbaijani: 'Azerbaijani',
        bahamian: 'Bahamian',
        bahraini: 'Bahraini',
        bangladeshi: 'Bangladeshi',
        barbadian: 'Barbadian',
        belarusian: 'Belarusian',
        belgian: 'Belgian',
        belizean: 'Belizean',
        beninese: 'Beninese',
        bhutanese: 'Bhutanese',
        bolivian: 'Bolivian',
        brazilian: 'Brazilian',
        british: 'British',
        bruneian: 'Bruneian',
        bulgarian: 'Bulgarian',
        burkinabe: 'Burkinabe',
        burundian: 'Burundian',
        cambodian: 'Cambodian',
        cameroonian: 'Cameroonian',
        canadian: 'Canadian',
        capeVerdian: 'Cape Verdian',
        chadian: 'Chadian',
        chilean: 'Chilean',
        chinese: 'Chinese',
        colombian: 'Colombian',
        congolese: 'Congolese',
        costaRican: 'Costa Rican',
        croatian: 'Croatian',
        cuban: 'Cuban',
        cypriot: 'Cypriot',
        czech: 'Czech',
        danish: 'Danish',
        dominican: 'Dominican',
        dutch: 'Dutch',
        ecuadorean: 'Ecuadorean',
        egyptian: 'Egyptian',
        emirian: 'Emirian',
        estonian: 'Estonian',
        ethiopian: 'Ethiopian',
        fijian: 'Fijian',
        filipino: 'Filipino',
        finnish: 'Finnish',
        french: 'French',
        gabonese: 'Gabonese',
        gambian: 'Gambian',
        georgian: 'Georgian',
        german: 'German',
        ghanaian: 'Ghanaian',
        greek: 'Greek',
        guatemalan: 'Guatemalan',
        guinean: 'Guinean',
        haitian: 'Haitian',
        honduran: 'Honduran',
        hungarian: 'Hungarian',
        icelander: 'Icelander',
        indian: 'Indian',
        indonesian: 'Indonesian',
        iranian: 'Iranian',
        iraqi: 'Iraqi',
        irish: 'Irish',
        israeli: 'Israeli',
        italian: 'Italian',
        ivorian: 'Ivorian',
        jamaican: 'Jamaican',
        japanese: 'Japanese',
        jordanian: 'Jordanian',
        kazakhstani: 'Kazakhstani',
        kenyan: 'Kenyan',
        northKorean: 'North Korean',
        southKorean: 'South Korean',
        kuwaiti: 'Kuwaiti',
        kyrgyz: 'Kyrgyz',
        laotian: 'Laotian',
        latvian: 'Latvian',
        lebanese: 'Lebanese',
        liberian: 'Liberian',
        libyan: 'Libyan',
        lithuanian: 'Lithuanian',
        luxembourgish: 'Luxembourgish',
        macedonian: 'Macedonian',
        malagasy: 'Malagasy',
        malawian: 'Malawian',
        malaysian: 'Malaysian',
        maldivan: 'Maldivan',
        malian: 'Malian',
        maltese: 'Maltese',
        mauritanian: 'Mauritanian',
        mauritian: 'Mauritian',
        mexican: 'Mexican',
        moldovan: 'Moldovan',
        mongolian: 'Mongolian',
        montenegrin: 'Montenegrin',
        moroccan: 'Moroccan',
        mozambican: 'Mozambican',
        namibian: 'Namibian',
        nepalese: 'Nepalese',
        newZealander: 'New Zealander',
        nicaraguan: 'Nicaraguan',
        nigerian: 'Nigerian',
        norwegian: 'Norwegian',
        pakistani: 'Pakistani',
        panamanian: 'Panamanian',
        paraguayan: 'Paraguayan',
        peruvian: 'Peruvian',
        polish: 'Polish',
        portuguese: 'Portuguese',
        qatari: 'Qatari',
        romanian: 'Romanian',
        russian: 'Russian',
        rwandan: 'Rwandan',
        salvadoran: 'Salvadoran',
        saudi: 'Saudi',
        scottish: 'Scottish',
        senegalese: 'Senegalese',
        serbian: 'Serbian',
        singaporean: 'Singaporean',
        slovakian: 'Slovakian',
        slovenian: 'Slovenian',
        somali: 'Somali',
        southAfrican: 'South African',
        spanish: 'Spanish',
        sriLankan: 'Sri Lankan',
        sudanese: 'Sudanese',
        swedish: 'Swedish',
        swiss: 'Swiss',
        syrian: 'Syrian',
        thai: 'Thai',
        togolese: 'Togolese',
        tunisian: 'Tunisian',
        turkish: 'Turkish',
        ugandan: 'Ugandan',
        ukrainian: 'Ukrainian',
        uruguayan: 'Uruguayan',
        uzbekistani: 'Uzbekistani',
        venezuelan: 'Venezuelan',
        vietnamese: 'Vietnamese',
        welsh: 'Welsh',
        yemeni: 'Yemeni',
        zambian: 'Zambian',
        zimbabwean: 'Zimbabwean'
      }
    },
    bodyWeight: {
      label: 'Body Weight',
      options: {
        underweight: 'Underweight',
        normalWeight: 'Normal weight',
        overweight: 'Overweight',
        obese: 'Obese'
      }
    },
    faceShape: {
      label: 'Face Shape',
      options: {
        oval: 'Oval',
        round: 'Round',
        square: 'Square',
        heartShaped: 'Heart-shaped',
        long: 'Long',
        rectangle: 'Rectangle',
        triangle: 'Triangle',
        invertedTriangle: 'Inverted Triangle',
        pearShaped: 'Pear-shaped',
        oblong: 'Oblong'
      }
    },
    facialFeatureDetails: {
      label: 'Facial Feature Details',
      options: {
        highNoseBridge: 'High nose bridge',
        shortNose: 'Short nose',
        largeEyes: 'Large eyes',
        smallEyes: 'Small eyes',
        highCheekbones: 'High cheekbones',
        smallMouth: 'Small mouth',
        fullLips: 'Full lips',
        perfectTeeth: 'Perfect teeth',
        squint: 'Squint',
        naturalExpression: 'Natural expression'
      }
    },
    eyeFeatures: {
      label: 'Eye Features',
      options: {
        doubleEyelids: 'Double eyelids',
        singleEyelids: 'Single eyelids',
        innerDoubleEyelids: 'Inner double eyelids',
        deepSetEyes: 'Deep-set eyes',
        bagsUnderEyes: 'Bags under eyes',
        eyeshadowEffect: 'Eyeshadow effect',
        eyeliner: 'Eyeliner'
      }
    },
    ears: {
      label: 'Ears',
      options: {
        visibleEars: 'Visible ears',
        hiddenEars: 'Hidden ears',
        largeEars: 'Large ears',
        smallEars: 'Small ears',
        piercedEars: 'Pierced ears',
        earrings: 'Earrings'
      }
    },
    skinDetails: {
      label: 'Skin Details',
      options: {
        smoothSkin: 'Smooth skin',
        spottedSkin: 'Spotted skin',
        dullSkin: 'Dull skin',
        healthyGlow: 'Healthy glow',
        naturalSkinTone: 'Natural skin tone',
        acneFreckles: 'Acne/Freckles',
        wrinklesAgedLook: 'Wrinkles/Aged look'
      }
    },
    skinTextureEffect: {
      label: 'Skin Texture Effect',
      options: {
        flawlessSkin: 'Flawless skin',
        texturedSkin: 'Textured skin',
        matteSkin: 'Matte skin',
        glossySkin: 'Glossy skin',
        enhancedDetailTexture: 'Enhanced detail texture'
      }
    },
    clothingStyle: {
      label: 'Clothing Style',
      options: {
        formalWear: 'Formal wear',
        suit: 'Suit',
        businessAttire: 'Business attire',
        eveningAttire: 'Evening attire',
        casualWear: 'Casual wear',
        sportswear: 'Sportswear',
        uniform: 'Uniform',
        weddingAttire: 'Wedding attire',
        traditionalCostume: 'Traditional costume',
        vintageRetroClothing: 'Vintage/Retro clothing'
      }
    },
    clothingTexture: {
      label: 'Clothing Texture',
      options: {
        silkGlossyTexture: 'Silk/Glossy texture',
        sweaterTexture: 'Sweater texture',
        leatherTexture: 'Leather texture',
        printedPattern: 'Printed pattern',
        denimTexture: 'Denim texture'
      }
    },
    headAccessories: {
      label: 'Head Accessories',
      options: {
        hat: 'Hat',
        glasses: 'Glasses',
        jewelry: 'Jewelry',
        hairAccessories: 'Hair accessories',
        faceAccessories: 'Face accessories'
      }
    }
  };
